import { render, staticRenderFns } from "./card-template-list.vue?vue&type=template&id=bf7a0540&scoped=true&"
import script from "./card-template-list.vue?vue&type=script&lang=ts&"
export * from "./card-template-list.vue?vue&type=script&lang=ts&"
import style0 from "./card-template-list.vue?vue&type=style&index=0&id=bf7a0540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7a0540",
  null
  
)

export default component.exports